import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { formatCurrency } from "../utils";
import { BASE_URL } from "./util/formatUtils";
import "./OrderSummaryModal.css";
import { FaSpinner } from "react-icons/fa";
import WinnerModal from "./WinnerModal";

export default function OrderSummaryModal({ isOpen, onClose }) {
  const { state, dispatch } = useCart();
  const [showWinner, setShowWinner] = useState(false);
  const [winnerNumber, setWinnerNumber] = useState(null);

  const [tableNumber, setTableNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [saving, setSaving] = useState(false);
  if (!isOpen) return null;

  const items = state.items;

  const subtotal = items.reduce((s, it) => {
    const complementosTotal = it.complementos
      ? Object.values(it.complementos)
          .flat()
          .reduce((x, c) => x + (Number(c.price) || 0), 0)
      : (it.extras || []).reduce((x, e) => x + (Number(e.price) || 0), 0);

    return s + (Number(it.price) + complementosTotal) * it.qty;
  }, 0);

  const orderNumber = Math.floor(Math.random() * 90000) + 10000;

  const orderUID = crypto.randomUUID();

  async function handleCloseOrder() {
    if (!tableNumber) {
      alert("Por favor ingresa el número de mesa");
      return;
    }

    if (!customerName) {
      alert("Por favor ingresa el Nombre");
      return;
    }

    if (items.length === 0) {
      alert("No hay productos en el pedido");
      return;
    }

    if (saving) return;

    setSaving(true);

    const payload = {
      orderNumber,
      timestamp: new Date().toISOString(),
      tableNumber,
      customerName,
      items,
      subtotal,
    };

    try {
      const response = await fetch(BASE_URL + "Carta/crearpedido.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      /* ==========================
       MESA Y NOMBRE COINCIDEN
    ========================== */

      if (data.status === "confirm_add") {
        const confirmar = window.confirm(
          "Ya existe un pedido abierto con esta mesa y nombre.\n\n¿Deseas agregar los productos al pedido actual?",
        );

        if (!confirmar) return;

        const payloadAgregar = {
          pedidoExistenteId: data.pedido_id,
          validarNombre: customerName,
          items,
          subtotal,
        };

        const resp2 = await fetch(BASE_URL + "Carta/crearpedido.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payloadAgregar),
        });

        const data2 = await resp2.json();

        if (data2.status === true) {
          alert("Productos agregados al pedido existente");
          dispatch({ type: "CLEAR_CART" });
          setTableNumber("");
          setCustomerName("");
        } else {
          alert(data2.message || "Error al agregar productos");
        }

        return;
      }

      /* ==========================
       VALIDAR NOMBRE
    ========================== */

      if (data.status === "require_name_validation") {
        alert(`La mesa ya tiene una cuenta abierta a nombre de otra persona`);

        const nombreValidacion = prompt(
          "Escribe el nombre del cliente que abrió la cuenta para confirmar:",
        );

        if (!nombreValidacion) return;

        const payloadAgregar = {
          pedidoExistenteId: data.pedido_id,
          validarNombre: nombreValidacion,
          items,
          subtotal,
        };

        const resp2 = await fetch(BASE_URL + "Carta/crearpedido.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payloadAgregar),
        });

        const data2 = await resp2.json();

        if (data2.status === true) {
          alert("Productos agregados al pedido existente");
          dispatch({ type: "CLEAR_CART" });
          setTableNumber("");
          setCustomerName("");
        } else {
          alert(data2.message || "El nombre no coincide");
        }

        return;
      }

      /* ==========================
       SIN STOCK
    ========================== */

      if (data.status === "sin_stock") {
        const mensaje = data.productos
          .map(
            (p) =>
              `${p.producto}\nDisponible: ${p.stock_disponible}\nSolicitado: ${p.solicitado}`,
          )
          .join("\n\n");

        alert("⚠ Inventario insuficiente:\n\n" + mensaje);
        return;
      }

      /* ==========================
       PEDIDO NUEVO
    ========================== */

      if (data.status === true) {
        const numeroCliente = Number(data.no_cliente);
        const esGanador = numeroCliente > 0 && numeroCliente % 100 === 0;

        if (esGanador) {
          setWinnerNumber(numeroCliente);
          setShowWinner(true);
        } else {
          alert(
            `Pedido Creado 🙌\n\nHay ${data.pedidos_antes} pedidos antes que el tuyo`,
          );
        }
        //console.log(JSON.stringify(data.no_cliente));
        dispatch({ type: "CLEAR_CART" });
        setTableNumber("");
        setCustomerName("");

        return;
      }

      alert(data.message || "Error al crear pedido");
    } catch (error) {
      console.error("Error:", error);
      alert("Error de conexión con el servidor");
    } finally {
      // 🔥 SIEMPRE se ejecuta
      setSaving(false);
    }
  }

  return (
    <div className="pos-overlay">
      <div className="pos-modal">
        {/* ENCABEZADO POS */}
        <div className="pos-header">
          <h2>LEVEL PUB-RESTAURANTE</h2>
          <p>Comanda #{orderNumber}</p>
          <p>{new Date().toLocaleString()}</p>
          <hr />
        </div>

        {/* TABLA POS */}
        <div className="pos-table-wrapper">
          <table className="pos-table">
            <thead>
              <tr>
                <th>Cant</th>
                <th className="left">Producto</th>
                <th>V.Unit</th>
                <th className="right">Subtotal</th>
              </tr>
            </thead>

            <tbody>
              {items.map((it, idx) => {
                const complementosTotal = it.complementos
                  ? Object.values(it.complementos)
                      .flat()
                      .reduce((x, c) => x + (Number(c.price) || 0), 0)
                  : (it.extras || []).reduce(
                      (x, e) => x + (Number(e.price) || 0),
                      0,
                    );

                const itemTotal =
                  (Number(it.price) + complementosTotal) * it.qty;

                return (
                  <tr key={idx} className="pos-item-row">
                    {/* NUEVA COLUMNA: ELIMINAR ITEM */}
                    <td className="center">
                      <div className="qty-controls">
                        <button
                          className="qty-btn"
                          onClick={() =>
                            dispatch({ type: "DECREMENT_ITEM", index: idx })
                          }
                        >
                          −
                        </button>

                        <span className="qty-value">{it.qty}</span>

                        <button
                          className="qty-btn"
                          onClick={() =>
                            dispatch({ type: "ADD_ITEM", payload: it })
                          }
                        >
                          +
                        </button>
                      </div>
                    </td>

                    <td className="left">
                      <strong>{it.name}</strong>

                      {it.complementos &&
                      Object.keys(it.complementos).length > 0 ? (
                        <div className="pos-extras-mobile">
                          {Object.entries(it.complementos).map(([cat, arr]) => {
                            if (!arr || arr.length === 0) return null;

                            return (
                              <div key={cat} style={{ marginTop: 6 }}>
                                <strong>{cat}:</strong>
                                {arr.map((c) => (
                                  <div key={c.id}>
                                    • {c.name}{" "}
                                    {(Number(c.price) || 0) > 0 && (
                                      <span className="extra-price">
                                        ({formatCurrency(Number(c.price))})
                                      </span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        // 🔁 fallback si aún tienes items viejos guardados con la estructura anterior
                        <>
                          {it.acompanamientos?.length > 0 && (
                            <div className="pos-acom">
                              Acomp:{" "}
                              {it.acompanamientos.map((a) => a.name).join(", ")}
                            </div>
                          )}

                          {(it.extras || []).length > 0 && (
                            <div className="pos-extras-mobile">
                              {Object.entries(
                                (it.extras || []).reduce((acc, e) => {
                                  const cat = e.categoria || "Otros";
                                  if (!acc[cat]) acc[cat] = [];
                                  acc[cat].push(e);
                                  return acc;
                                }, {}),
                              ).map(([cat, arr]) => (
                                <div key={cat} style={{ marginTop: 8 }}>
                                  <strong>{cat}</strong>

                                  <div style={{ marginTop: 4 }}>
                                    {arr.map((e) => (
                                      <div key={e.id}>
                                        • {e.name}{" "}
                                        {(Number(e.price) || 0) > 0 && (
                                          <span className="extra-price">
                                            ({formatCurrency(Number(e.price))})
                                          </span>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      )}

                      {it.note && (
                        <div className="pos-note">Nota: {it.note}</div>
                      )}
                    </td>

                    <td className="center">{formatCurrency(it.price)}</td>

                    <td className="right">{formatCurrency(itemTotal)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* DATOS DEL CLIENTE / MESA */}
        <div className="pos-client-info">
          <div className="pos-field">
            <label>Número de mesa</label>
            <input
              type="number"
              placeholder="Ej: 5"
              value={tableNumber}
              onChange={(e) => setTableNumber(e.target.value)}
            />
          </div>

          <div className="pos-field">
            <label>Nombre del cliente</label>
            <input
              type="text"
              placeholder="Ej: Juan"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
          </div>
        </div>

        {/* TOTAL */}
        <div className="pos-total">
          <hr />
          <h3>Total a pagar: {formatCurrency(subtotal)}</h3>
        </div>

        {/* BOTONES */}
        <div className="pos-actions">
          <button className="btn-cancel" onClick={onClose}>
            Volver
          </button>
          <button
            className="btn-confirm"
            onClick={handleCloseOrder}
            disabled={saving}
          >
            {saving ? (
              <>
                <FaSpinner className="spin" /> Enviando...
              </>
            ) : (
              "Hacer Pedido"
            )}
          </button>
        </div>
      </div>
      {showWinner && (
        <WinnerModal
          numero={winnerNumber}
          onClose={() => setShowWinner(false)}
        />
      )}
    </div>
  );
}
